import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ContextApp } from "../../context/ContextApp"
import { validateLogin } from "../../helpers/validateForms";

import Titulo from "../../components/titles/Titulo";
import InputJim from "../../components/inputs/inputs/InputJim";
import CheckJim from "../../components/inputs/inputs/CheckJim";

import '../pageStyles.css'
import './login.css'

const Login = ({ setLogeado }) => {

  const initialErrors = {
    nombre: '',
    password: ''
  }
  const navigate = useNavigate();
  const { user, setUser, loginUp } = useContext(ContextApp);

  const [errors, setErrors] = useState(initialErrors);
  const [errorLogin, setErrorLogin] = useState('');
  const [remember, setRemember] = useState(false);

  useEffect(() => {
    const datos = localStorage.getItem('user')
    datos && setUser(JSON.parse(datos));
    user && setRemember(true)
  }, [setUser])



  const handleChange = (name, value) => {
    setUser({ ...user, [name]: value })
  }

  const validateData = async (name, value) => {
    const error = await validateLogin(name, value)
    setErrors({ ...errors, [name]: error })
  }

  const checkRemember = (e, newValue) => {
    setRemember(!remember)

  }

  const login = async (e) => {
    e.preventDefault()
    if (user.nombre === '' || user.password === '') return setErrorLogin('Hay campos vacíos')
  
    const res = await loginUp(user);
    
    if (res.response){
      setErrorLogin(res.response.data.error)
      navigate("/")
      // return
    }
    else {
      remember ? localStorage.setItem('user', JSON.stringify(user)) : localStorage.removeItem('user')
      setLogeado(true)
    }
  }

  return (
    <div className="container-data login">
      <Titulo>ACCESO</Titulo>

      <div className="data-logo logo-login" />

      <form className="form-login">

        <InputJim classN='span'
          type='text'
          name='nombre'
          value={user.nombre}
          onChange={handleChange}
          onBlur={validateData}
          placeholder='escribe nombre'
          error={errors.nombre} />
        <InputJim classN='span'
          type='password'
          name='password'
          value={user.password}
          onChange={handleChange}
          onBlur={validateData}
          placeholder='escribe contraseña'
          error={errors.password} />
        <CheckJim
          name='remember'
          label='Recordarme'
          value={remember}
          checked={remember}
          onChange={checkRemember}
          error='' />
        <button className="btn" onClick={(e) => login(e)}>ACEPTAR</button>
      </form>

      <p className="error-login">{errorLogin}</p>

    </div>
  )
}
export default Login